import { Paginatable } from "../common/Paginatable.dto";

export class GovAddress {
  roadAddr: string;
  roadAddrPart1: string;
  roadAddrPart2?: string;
  jibunAddr: string;
  engAddr: string;
  zipNo: string;
  admCd: string;
  rnMgtSn: string;
  bdMgtSn: string;
  detBdNmList?: string;
  bdNm?: string;
  bdKdcd: string;
  siNm: string;
  sggNm: string;
  emdNm: string;
  liNm?: string;
  rn: string;
  udrtYn: string;
  buldMnnm: string;
  buldSlno: string;
  mtYn: string;
  lnbrMnnm: string;
  lnbrSlno: string;
  emdNo: string;
  hstryYn: string;
  relJibun?: string;
  hemdNm?: string;
}

export enum GovAddressResponseCode {
  Success = "0",
  System_Error = "-999",
  Not_Authorized_Key = "E0001",
  Empty_Search_Keyword = "E0005",
  Too_Wide_Keyword = "E0006",
  Too_Short_Keyword = "E0008",
  Not_Authorized_Only_Number_Keyword = "E0009",
  Too_Long_Keyword = "E0010",
  Too_Long_Number_Keyword = "E0011",
  Special_Number_Keyword = "E0012",
  Reseved_SQL_Keyword_Contain = "E0013",
  Expired_Api_Key = "E0014",
  Too_Many_Search_Result = "E0015",
}

export enum GovAddressSortType {
  Accuracy = "ACCURACY",
  Road = "ROAD",
  Location = "LOCATION",
}

export interface PaginateGovAddressRequest {
  keyword: string;
  includeChangedAddress: boolean;
  sort: GovAddressSortType;
  page: number;
  rpp: number;
}

export type PaginateGovAddressResponse = Paginatable<GovAddress>;
